import React, { useMemo } from 'react';
import { graphql } from 'gatsby';
import SimpleHeader from 'design-system/src/components/organisms/website/SimpleHeader';

import { i18n } from './../../../i18n';

export default function Header({
    data,
    alternateLanguages,
    layoutProps,
    sliceContext,
}) {
    const {
        headerItems: { nodes: navs },
    } = data;
    const { language } = sliceContext;

    const { theme } = layoutProps;

    const nav = useMemo(
        () =>
            navs.map((item) => ({
                children: item.label,
                href: item?.href ?? '#',
                tabIndex: -1,
                items: item.childLinks?.length
                    ? item.childLinks
                          .sort((a, b) => a.position - b.position)
                          .map((subitem) => ({
                              children: subitem.label,
                              href: subitem.href,
                              tabIndex: -1,
                          }))
                    : [],
            })),
        [navs],
    );

    return (
        <SimpleHeader
            nav={nav}
            theme={theme === 'dark' ? 'dark' : 'light'}
            logoLink={{
                href: i18n.primaryLanguage === language ? '/' : `/${language}`,
                title: 'Cuerva',
            }}
            language={language}
            alternateLanguages={alternateLanguages}
        />
    );
}

export const query = graphql`
    fragment HeaderLink on DatoCmsHeader {
        label
        href
        meta {
            createdAt
            updatedAt
        }
    }
    query Header($language: String) {
        headerItems: allDatoCmsHeader(
            filter: {
                treeParent: { id: { eq: null } }
                locale: { eq: $language }
            }
            sort: { position: ASC }
        ) {
            nodes {
                ...HeaderLink
                childLinks: treeChildren {
                    position
                    ...HeaderLink
                }
            }
        }
    }
`;
